import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export const SemiAnnual = [
  {
    label: "First (Jan-Jun)",
    value: 1,
  },
  {
    label: "Second (Jul-Dec)",
    value: 2,
  },
];

export const QuartelyOptions = [
  {
    label: "First quarter (Jan-Mar)",
    value: 1,
  },
  {
    label: "Second quarter (Apr-Jun)",
    value: 2,
  },
  {
    label: "Third quarter (Jul-Sep)",
    value: 3,
  },
  {
    label: "Fourth quarter (Oct-Dec)",
    value: 4,
  },
];

export const columns = [
  {
    label: "Company name",
    columnName: "companyName",
    width: "150",
  },
  {
    label: "Plan ID",
    columnName: "rkPlanNumber",
    width: "100",
  },
  {
    label: "Allocation source",
    columnName: "allocationSource",
    width: "150",
  },
  {
    label: "Plan year",
    columnName: "planYear",
    width: "100",
  },
  {
    label: "Generation date",
    columnName: "reportGenerationDate",
    width: "200",
  },
  {
    label: "Report status",
    columnName: "reportStatus",
    width: "200",
  },
  {
    label: "Action",
    columnName: "action",
    width: "200",
  },
];

export const MonthlyOptions = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const AllocationCalculationPeriod = [
  {
    label: "Annual",
    value: 1,
  },
  {
    label: "Semiannual",
    value: 2,
  },
  {
    label: "Quarterly",
    value: 3,
  },
  {
    label: "Monthly",
    value: 4,
  },
  {
    label: "Custom",
    value: 5,
  },
];

export const EligiblePayPeriodDetermination = (x) => {
  switch (x) {
    case 1:
      return <div className="ft-14 fw-500">Pay date</div>;
    case 2:
      return <div className="ft-14 fw-500">Pay period end date</div>;
  }
};

export const ProcessStatus = (x) => {
  switch (x) {
    case 1:
      return (
        <div className="d-flex mt-2">
          <FontAwesomeIcon
            icon={faCircle}
            size="sm"
            color="#037EA0"
            className="tableIcon"
          />
          <p className="fw-500 inProgessTag">In-progress</p>
        </div>
      );

    case 2:
      return (
        <div className="d-flex mt-2">
          <FontAwesomeIcon
            icon={faCircle}
            size="sm"
            color="#178737"
            className="tableIcon"
          />
          <p className="fw-500 completedTag">Completed</p>
        </div>
      );
    case 3:
      return (
        <div className="d-flex mt-2">
          <FontAwesomeIcon
            icon={faCircle}
            size="sm"
            color="#ad112b"
            className="tableIcon"
          />
          <p className="fw-500 failedTag">Failed to generate</p>;
        </div>
      );
  }
};

export const NonPayPeriodYesandNo = (x) => {
  switch (x) {
    case false:
      return <p className="fw-500">No</p>;
    case true:
      return <p className="fw-500">Yes</p>;
  }
};

export const EmployerContributionType = (employerContributionType) => {
  switch (employerContributionType) {
    case 1:
      return <p className="fw-500">Percentage of Compensation</p>;
    case 2:
      return <p className="fw-500">Dollar</p>;
  }
};

export const GetContributionType = (
  employerContributionType,
  isSafeHarbour,
  SafeHarbourType
) => {
  if (employerContributionType) {
    switch (employerContributionType) {
      case 2:
        return <p className="fw-500">Percentage match on deferral</p>;
      case 3:
        return <p className="fw-500">Tiered match</p>;
    }
  } else if (isSafeHarbour) {
    switch (SafeHarbourType) {
      case 1:
        return <p className="fw-500">Basic safe harbour match</p>;
      case 2:
        return <p className="fw-500">QACA safe harbour match</p>;
      case 3:
        return <p className="fw-500">Enhanced safe harbour match</p>;
    }
  }
};

export const GetRetirementDateRule = (value) => {
  switch (value) {
    case 1:
      return "Date the participant reaches early retirement";
    case 2:
      return "First day of month ERA attainment";
  }
};

export function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export const getDateRange = (year, startMonth, startDay, endMonth, endDay) => ({
  startDate: new Date(year, startMonth, startDay),
  endDate: new Date(year, endMonth, endDay),
});
